import { Component, Input, OnInit } from "@angular/core";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Aeroplanta } from "src/app/shared/models/cierreTurno/Aeroplanta";
import { CierreTurnoService } from "src/app/cierreTurno/cierre-turno.service";
import { NgxSpinnerService } from "ngx-spinner";
import { NotificacionesService } from "@abm/notificacion/notificaciones.service";
import { MessageService } from "@shell/message.service";
import { AbstractControl, FormControl, ValidationErrors, Validators } from "@angular/forms";
import { CustomValidatorsService } from "@shared/validators/custom-validators.service";

@Component({
  selector: "app-modal-agregar-email-aerovale",
  templateUrl: "./modal-agregar-email-aerovale.component.html",
  styleUrls: ["./modal-agregar-email-aerovale.component.scss"],
})
export class ModalAgregarEmailAerovaleComponent implements OnInit {
  aeroplantas: Aeroplanta[];
  aeroplantasAsignadas: Aeroplanta[];
  correosAerovalesArray: string[];
  showSpinner: boolean;
  aeroplantasLista: Aeroplanta[];
  @Input() notificacionCliente;
  @Input() configCorreoXAeroplanta;
  @Input() cuentaSgc;
  error: string = null;
  emailFormControl = new FormControl(null, [Validators.required, this.multipleEmailsValidator.bind(this)]);

  constructor(
    private activeModal: NgbActiveModal,
    private cierreTurnoService: CierreTurnoService,
    private spinner: NgxSpinnerService,
    private notificacionesService: NotificacionesService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    //traerEmails
    this.aeroplantas = [];
    this.aeroplantasAsignadas = [];
    this.obtenerAeroplantas();
  }

  mostrarSpinner() {
    this.showSpinner = true;
    this.spinner.show("spinnerGrafico");
  }

  ocultarSpinner() {
    this.showSpinner = false;
    this.spinner.hide("spinnerGrafico");
  }

  obtenerAeroplantas() {
    this.mostrarSpinner();
    const aeroplantasAFiltrar = ['CUT','DTO','ENO','JNI','TDL'];
    this.cierreTurnoService.getAeroplantas3().subscribe(
      (a) => {
        this.aeroplantas = a.sort((a, b) => {
          {
            if (a.nombre > b.nombre) {
              return 1;
            } else {
              return -1;
            }
          }
        });
        this.aeroplantas = this.aeroplantas.filter(
          (a) => !aeroplantasAFiltrar.includes(a.codigo)
        );
        this.aeroplantas.forEach(
          (aeroplanta) => (aeroplanta.seleccionada = false)
        );
        this.aeroplantasLista = [];
        for (let i = 0; i < this.aeroplantas.length; i++) {
          this.aeroplantasLista.push(this.aeroplantas[i]);
        }
        this.ocultarSpinner();
      },
      () => {
        this.ocultarSpinner();
      }
    );
  }

  // Validador personalizado para correos electrónicos múltiples
  multipleEmailsValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value == null) {
      return null;
    }

    const emails = value.split(';'); // Armo un array de email
    for (let email of emails) {
      email = email.trim();
      if (email && CustomValidatorsService.emailValidator({ value: email } as AbstractControl)) {
        return { multipleEmails: true };
      }
    }
    return null;
  }

  agregarCorreos() {
    if (this.aeroplantasAsignadas.length == 0) {
      this.messageService.showErrorMessage("Debe asignar al menos una aeroplanta.");
      return;
    }

    this.mostrarSpinner();
    this.correosAerovalesArray = this.email.value.trim().split(";");
    this.aeroplantasAsignadas.forEach((aeroplanta) => {
      let emails = this.obtenerCorreos(aeroplanta.codigo);
      console.log(
        "cod: ",
        aeroplanta.codigo,
        " - emails: ",
        emails,
        " - correos: ",
        this.correosAerovalesArray
      );
      (emails != null) ? emails = emails.concat(this.correosAerovalesArray) : emails = this.correosAerovalesArray;

      this.notificacionCliente.notificaciones.push({
        aeroplantas: [
          {
            nombre: aeroplanta.nombre,
            codigoAeroplanta: aeroplanta.codigo,
            correosElectronicos: emails,
          },
        ],
        emails: emails,
        cuentaCliente: { cuentaSgc: this.cuentaSgc },
        documentos: [0],
        activo: true,
      });
    });
    this.notificacionesService
      .actualizarNotificacionesEmailAerovales(this.notificacionCliente)
      .subscribe(
        () => {
          this.messageService.showSuccessMessage(
            "Los correos se guardaron exitosamente."
          );
          this.activeModal.close();
          this.ocultarSpinner();
        },
        () => {
          this.messageService.showErrorMessage("Error al guardar los correos.");
          this.aeroplantasAsignadas = [];
          this.aeroplantas = this.aeroplantasLista;
          this.ocultarSpinner();
        }
      );
  }

  obtenerCorreos(codigo: string): string[] {
    const emails = this.configCorreoXAeroplanta.find(
      (a) => a.codigoAeroplanta === codigo
    );    
    if (emails != undefined) {
      return emails.correosElectronicos;
    } else {
      return null
    }    
  }

  cancelar() {
    this.activeModal.dismiss();
  }

  asignarTodas() {
    this.aeroplantasAsignadas = Array.from(this.aeroplantasLista);
    this.aeroplantas = [];
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  get email() {
    return this.emailFormControl;
  }
}
